import React from "react";
import {Provider} from "react-redux";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {CssBaseline, ThemeProvider} from "@mui/material";

import MainPage from "./pages/mainPage";
import Login from "./pages/login/Login";
import {AdminPanelPage} from "./pages/adminPanel/AdminPanelPage";
import {PrivateRoute} from "./components/PrivateRoute/PrivateRoute";

import theme from "./components/styles/theme/theme";
import store from "./store/store";

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline/>
          <Router>
            <Routes>
              <Route path="/" element={<PrivateRoute/>}>
                <Route path="/" element={<MainPage/>}/>
                <Route path="/admin-panel" element={<AdminPanelPage/>}/>
              </Route>
              <Route path="/login" element={<Login/>}/>
            </Routes>
          </Router>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
